import React, { useEffect, useRef, useState } from 'react';
import { Descriptions, Table, Modal, ConfigProvider } from 'antd';
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";
import { useSelector } from 'react-redux';
import ReportTitle from "../../assets/icons/ReportTitle.svg";
import ReportSymbol from "../../assets/icons/ReportSymbol.svg";
import '../../css/pdf.css';
import VesselParticulars from './VesselParticulars';
import Period from './Period';
import SailingMonitor from './SailingMonitor';
import PortMonitor from './PortMonitor';
import AlldataContainer from './AllDataContainer';
import MapContainer from './MapContainer';
import { fetchGoogleMapDetails } from '../../features/Vessels/VesselSlice';

const ReportPdf = ({ icon, label }) => {
    const { statementDocument } = useSelector((state) => state.voyage);
    const { period } = statementDocument || {};
    const pdfRef = useRef();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [editedValues, setEditedValues] = useState({
        start_date: period?.start_date,
        end_date: period?.end_date,
      });

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);

        setEditedValues({
            start_date: period?.start_date,
            end_date: period?.end_date,
          });
    };

    const createPDF = async () => {
        const pdf = new jsPDF();
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
    
        const pdfElement = document.querySelector("#pdf");
        const images = pdfElement.querySelectorAll("img");
    
        await Promise.all(
            Array.from(images).map(
                (img) =>
                    new Promise((resolve) => {
                        if (img.complete) resolve();
                        else img.onload = img.onerror = resolve;
                    })
            )
        );
    
        const data = await html2canvas(pdfElement, {
            scale: 2,
            useCORS: true,
        });
        const img = data.toDataURL("image/jpeg", 0.7); // JPEG format with 70% quality.
    
        const imgProperties = pdf.getImageProperties(img);
        const imgRatio = imgProperties.width / imgProperties.height;
        const pdfRatio = pdfWidth / pdfHeight;
    
        let imgWidth, imgHeight;
        if (imgRatio > pdfRatio) {
            imgWidth = pdfWidth;
            imgHeight = pdfWidth / imgRatio;
        } else {
            imgHeight = pdfHeight;
            imgWidth = pdfHeight * imgRatio;
        }
    
        const xOffset = (pdfWidth - imgWidth) / 2;
        const yOffset = (pdfHeight - imgHeight) / 2;
    
        pdf.addImage(img, "JPEG", xOffset, yOffset, imgWidth, imgHeight);
    
        const { report_number } = statementDocument;
        const imo_number = statementDocument?.vessel_particulars?.imo_number;
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}${(currentDate.getMonth() + 1).toString().padStart(2, "0")}${currentDate.getFullYear()}`;
        const filename = `EVS-${report_number}-${formattedDate}.pdf`;
    
        pdf.save(filename);
    };
    


    return (
        <ConfigProvider
            theme={{
                components: {
                    Descriptions: { labelBg: "#F4F7FF" },
                    Table: { headerBg: "#F4F7FF", borderColor: "rgb(0,0,0)", headerBorderRadius: 8 },
                },
                token: { borderRadius: 8 }
            }}
        >
            <Modal
                title="Download Report PDF"
                style={{ top: 20 }}
                width={"90%"}
                open={isModalOpen}
                onOk={createPDF}
                onCancel={handleCancel}
                cancelButtonProps={{ className: 'custom-cancel-btn' }}
                okButtonProps={{ className: 'custom-OK-btn' }}
                okText="Download"
            >
                <div className='pdf-Main-Container'>
                    <div id="pdf" ref={pdfRef}>
                        <div className='pdf-icon-div'>
                            <img className='pdf-icon-first' src={ReportTitle} alt="" />
                            <img className='pdf-icon-second' src={ReportSymbol} alt="" />
                        </div>
                        <div className='pdf-info-container'>
                            <h1>EMISSIONS VOYAGE STATEMENT</h1>
                            <div className='pdf-description-details'>
                                <div className='pdf-description-details-main pdf-description-second'>
                                    <div className='pdf-description-details-box'>
                                        <p>Report No.:</p>
                                        <p>{statementDocument?.report_number}</p>
                                    </div>
                                    <div className='pdf-description-details-box'>
                                        <p>Owner:</p>
                                        <p>{statementDocument?.active_owner}</p>
                                    </div>
                                </div>
                                <div className='pdf-description-details-main pdf-description-second'>
                                    <div className='pdf-description-details-box'>
                                        <p>ISM Manager :</p>
                                        <p>{statementDocument?.managers_doc_holder}</p>
                                    </div>
                                    <div className='pdf-description-details-box'>
                                        <p>Date of Issue:</p>
                                        <p>{statementDocument?.date_of_issue}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='pdf-data-partition'>
                                <div className='pdf-data-partition-div'>
                                    <div className="pdf-table-container">
                                        <h3>Vessel Particulars: </h3>
                                        <VesselParticulars />
                                    </div>
                                    <div className="pdf-table-container">
                                        <h3>Period: </h3>
                                        <Period editedValues={editedValues} setEditedValues={setEditedValues}/>
                                    </div>

                                </div>
                                <div className='pdf-data-partition-div'>
                                    <div className="pdf-map-container">
                                        <div className="pdf-table-container">
                                            <h3>Voyage Map: </h3>
                                            <MapContainer />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="pdf-table-container">
                                <h3>Results from monitoring of the parameters: (At Port)</h3>
                                <PortMonitor />
                            </div> */}
                            <div className="pdf-table-container">
                                <h3>Results from monitoring of the parameters:</h3>
                                <SailingMonitor />
                            </div>
                            <div className="pdf-table-container">
                                <AlldataContainer />
                            </div>
                        </div>
                        <div className='pdf-description-details'>
                            <div className='pdf-description-details-main'>
                                <div className='pdf-description-details-box pdf-description-footer'>
                                    {/* <p>Report No.:</p>
                                    <p>01</p>
                                    <p>of total generated</p>
                                    <p>06</p>
                                    <p>reports.</p> */}
                                </div>
                                <p className='pdf-description-footer-info'>
                                    All the emission factor considered for the indicated fuels are as per the Annex 1 to the Comission Delegated Regulation  (EU) 2015/757 of the European Parliament and of the
                                    Council as regards the rules for monitoring greenhouse gas emissions and relevant information from marine transport. (Issued at Brussles,12.10.2023)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {statementDocument == null ? "" :
                <div onClick={showModal}>
                    <img src={icon} style={{ height: "20px" }} alt="" />
                    <span className='card-icon-span'>{label}</span>
                </div>}
        </ConfigProvider>
    );
}

export default ReportPdf;
